import { Menu, MenuItem, Box, Typography } from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ButtonNavbar } from "./ButtonNavbar";

export const NavBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState("");
  const navigate = useNavigate();

  const menuItems = [
    { label: "INÍCIO", hasDropdown: false, route: "/home" },
    { label: "SOBRE NÓS", hasDropdown: false, route: "/sobre" },
    { label: "MINISTRAÇÕES", hasDropdown: false, route: "/ministracoes" },
    { label: "EVENTOS", hasDropdown: false, route: "/eventos" },
    { label: "INSCRIÇÕES", hasDropdown: false, route: "/inscricoes" },
    {
      label: "VERBO SHOP",
      hasDropdown: false,
      route: () => window.open("https://verboshop.com.br/", "_blank"),
    },
    {
      label: "CADASTRO DE MEMBROS",
      route: () => window.open("https://verbo.link/membroszonasulcg", "_blank"),
    },
    { label: "CONTATO", hasDropdown: false, route: "/contato" },
  ];

  const handleMenuClick = (route) => {
    if (typeof route === "function") {
      route();
    } else {
      navigate(route);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {menuItems.map((item, index) => (
          <ButtonNavbar
            key={index}
            hasDropdown={false}
            onClick={() => handleMenuClick(item.route)}
          >
            {item.label}
          </ButtonNavbar>
        ))}
      </Box>
    </>
  );
};
